// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_25d45facb5--dropdown--J3Sfn"};